import { forwardRef, useEffect, useRef } from "react";
import NotificationModal from "components/Modal/Notification/NotificationModal";
import tw, { styled } from "twin.macro";
import '../style.css'

const Title = styled.h3(({ fontSize }) => [
  `color: var(--color-primary);
text-align: center;
font-family: Barlow Condensed;
 font-size: ${fontSize || "40px"};
text-transform: uppercase;
font-style: normal;
font-weight: 700;
line-height: 110%;`,
  tw`mt-[19px]`,
]);

const Subtitle = styled.span(({ fontSize }) => [
  `color: #343434;

text-align: center;
font-family: Montserrat;
font-size: ${fontSize || "14px"};
font-style: normal;
font-weight: 400;
line-height: 120%;`,
  tw`mt-[12px]`,
]);

export const SimpleIconNotification = forwardRef(
  (
    {
      Icon,
      title,
      subtitle,
      prompt,
      confirm,
      children,
      update = true,
      onClose,
      fontSize = "",
      subTitleFont = "",
      showHeader,
      shouldCloseOnOverlayClick,
    },
    ref
  ) => {
    const refm = useRef();

    useEffect(() => {
      ref.current = refm.current;
    }, [ref]);

    return (
      update && (
        <NotificationModal shouldCloseOnOverlayClick={shouldCloseOnOverlayClick} showHeader={showHeader} ref={refm} onClose={onClose}>
          {{
            content: (
              <>
                <div className="simple-notification-modal-content w-[400px]">
                  <div className="simple-notification-content flex flex-col items-center pt-[3px] pb-[12px]">
                    {Icon && (
                      <div className="simple-content-icon">
                        <Icon />
                      </div>
                    )}
                    <Title fontSize={fontSize} className="simple-content-title">{title}</Title>
                    <Subtitle fontSize={subTitleFont} className="simple-content-subtitle">
                      {subtitle}
                    </Subtitle>
                    {prompt}
                    {confirm}
                    <div>{children}</div>
                  </div>
                </div>
              </>
            ),
          }}
        </NotificationModal>
      )
    );
  }
);
